import classNames from 'classnames'
import { Icon } from 'components/common/Icon'
import { PropsWithClassName } from 'types'

const colorVariants = {
  lightGreen: 'bg-[#00B67A]',
  darkGreen: 'bg-emerald-900',
} as const

export type TrustpilotStarColor = keyof typeof colorVariants

interface Props extends PropsWithClassName {
  iconSize?: number
  color?: TrustpilotStarColor
}

export function TrustpilotStar({
  className,
  iconSize,
  color = 'lightGreen',
}: Props) {
  return (
    <div
      className={classNames(
        'relative flex items-center justify-center rounded-[1px] p-0.5',
        colorVariants[color],
        className
      )}
    >
      <Icon name='trustpilot-star' custom size={iconSize} />
    </div>
  )
}
